<template>
  <div>Module error</div>
</template>

<script>
export default {
  components: {}
}
</script>
